import { http } from "@next-core/http";
/**
 * @description 获取elevo项目列表
 * @endpoint list /api/v1/elevo/projects
 */
export const ElevoApi_getElevoProjects = async (params, options) => /**! @contract easyops.api.llm.elevo.GetElevoProjects@1.0.0 */(await http.get("api/gateway/logic.llm.aiops_service/api/v1/elevo/projects", {
  ...options,
  params
})).data;
//# sourceMappingURL=getElevoProjects.js.map